import { render, staticRenderFns } from "./SecurityPage.vue?vue&type=template&id=fa3b2f1e&scoped=true&"
import script from "./SecurityPage.vue?vue&type=script&lang=js&"
export * from "./SecurityPage.vue?vue&type=script&lang=js&"
import style0 from "./SecurityPage.vue?vue&type=style&index=0&id=fa3b2f1e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa3b2f1e",
  null
  
)

export default component.exports